module.exports = "fragment FlagFragment on Flag {\n  __typename\n  id\n  name\n}\n"